module.exports = __webpack_public_path__ + "media/images/pc/components/specials/campaign_card/detail_link-9d5f7db80d0a8947f3a81807a53256a4.png";